<template>
  <div :class="'base-create ' + (isDisabledComponent ? 'create-study-set-com-disable' : '')">
    <div class="base-create-body">
      <el-form :rules="rules" :disabled="isDisabledComponent" :model="studySetDetails" class="create-edit-form" ref="firstForm" hide-required-asterisk>
        <elsa-input v-model="studySetDetails.name" :label="$t('study_sets.form.study_set_name')" :placeholder="$t('study_sets.form.name_your_study_set')" name="name" />
        <el-row class="form-row">
          <el-col :md="12" :xs="24">
            <div class="pick-shareable-to">
              <elsa-select
                popper-class="emails-list-popover"
                name="shareable"
                :information="shareableTooltip"
                :label="$t('study_sets.form.shareable_to')"
                :options="shareableOptionsWithI18n"
                :placeholder="$t('study_sets.form.shareable_to')"
                @change="changeShareable"
                v-model.lazy="studySetDetails.shareable"
                :no-data-text="$t('study_sets.form.no_data_text')"
              />
            </div>
          </el-col>
          <el-col :md="12" :xs="24">
            <div class="pick-category">
              <elsa-select
                popper-class="emails-list-popover"
                name="category"
                :label="$t('study_sets.form.category')"
                :options="categoryOptions"
                :placeholder="$t('study_sets.form.category')"
                @change="changeCategory"
                v-model.lazy="studySetDetails.category"
                :no-data-text="$t('study_sets.form.no_data_text')"
              />
            </div>
          </el-col>
          <elsa-tags-input
            :displayCount="true"
            :information="$t('information.study_set_input_items')"
            :label="$t('study_sets.form.input_phrases')"
            :placeholder="$t('study_sets.form.type_in_phrases_press_enter_to_seperate')"
            :maxTags="50"
            :validations="[]"
            :currentTags="studySetDetails.phrases"
            :separators="[';']"
            :addOnkey="[13,'\n']"
            :allowEditTags="true"
            @updatedTags="setTags"
            ref="tags"
            name="phrases"
            :maxCharactersAllow="300"
          />
        </el-row>
      </el-form>
    </div>
    <checking-modal
      :dialogVisible="showModalSpellCheck"
      append-to-body
      v-on:closed="showModalSpellCheck = false"
      :checkingType="modalCheckType"
      v-on:proceed="handleProceed"
    />
  </div>
</template>

<script>
import ElsaInput from '@/components/common/Input'
import ElsaTagsInput from '@/components/common/TagsInput'
import { handleFormValidation } from '../../../helpers/formValidationHelper'
import { mapGetters, mapActions } from 'vuex'
import ElsaSelect from '@/components/common/Select'
import { path, pathOr } from 'ramda'
import axios from '@/utils/axios'
import { DefaultShareableOptions, DefaultCategoryOptions } from '@/constants/studySets'
import { valuesToOptions } from '@/utils/elementUi'
import CheckingModal from '@/components/modals/studysets/CheckingModal'

export default {
  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    componentStep: {
      type: Number,
      default: 1
    },
    editMode: {
      type: Boolean,
      default: false
    },
    tertiaryFunction: {
      type: Function,
      default: null
    },
    organizationType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        name: path(['studySetDetails', 'name'])(this),
        phrases: path(['studySetDetails', 'phrases'])(this),
        shareable: path(['studySetDetails', 'shareable'])(this),
        category: path(['studySetDetails', 'category'])(this)
      },
      rules: {
        name: { required: true, type: 'string', message: this.$t('study_sets.errors.please_provide_name') },
        shareable: { required: true, message: this.$t('study_sets.errors.please_provide_shareable_to'), trigger: 'change' },
        category: { required: true, message: this.$t('study_sets.errors.please_provide_category'), trigger: 'change' }
      },
      shareableOptions: DefaultShareableOptions,
      categoryOptions: DefaultCategoryOptions,
      modalCheckType: "limit",
      showModalSpellCheck: false
    }
  },
  computed: {
    ...mapGetters({
      studySet: 'studysets/getBuildingStudySet',
      currentOrganizationId: 'organization/currentOrganizationId',
      categories: 'studysets/getStudySetCategories',
      hasChildOrg: 'organization/hasChildOrg',
      isTeacherRole: 'organization/isOrganizationTeacherOnly'
    }),
    studySetDetails() {
      return this.studySet
    },
    modalTitle() {
      return this.currentStep === -1 ? this.$t(this.$i18nLabelsHelper(this.organizationType, 'group_details')) : this.$t(this.$i18nLabelsHelper(this.organizationType, 'step_group_details'))
    },
    isDisabledComponent() {
      return this.currentStep > this.componentStep && this.editMode == false
    },
    shareableOptionsWithI18n() {
      let shareableOptionsFilter = this.shareableOptions;
      let filterOptions = [];
      if (this.isTeacherRole) {
        filterOptions.push('organization');
      }
      if (!this.hasChildOrg)
        filterOptions.push('branch');

      shareableOptionsFilter = this.shareableOptions.filter((x) => !filterOptions.includes(x.value) )
      return shareableOptionsFilter.map((x) => {
        return { ...x, label: this.$t(this.$i18nLabelsHelper(this.organizationType, `study_sets.${x.label}`)) }
      })
    },
    shareableTooltip() {
      const tooltipClass = this.$t(this.$i18nLabelsHelper(this.organizationType, 'content_shareable.tooltip_shareable_to_my_class'));
      const tooltioOrg = this.$t('common.content_shareable.tooltip_shareable_to_this_org');
      let tooltip = this.isTeacherRole ? `${tooltipClass}` : `${tooltipClass} \n\n${tooltioOrg}`;
      if (this.hasChildOrg)
        tooltip = `${tooltip} \n\n${this.$t('common.content_shareable.tooltip_shareable_to_branch')}`;
      // hide for now
      // const tooltipPublic = this.$t('common.content_shareable.tooltip_shareable_to_public')
      return tooltip;
    },
  },
  components: {
    ElsaInput,
    ElsaSelect,
    ElsaTagsInput,
    CheckingModal
  },
  methods: {
    ...mapActions({
      updateBuildingStudySet: 'studysets/updateBuildingStudySet'
    }),
    handleContinueClick() {
      handleFormValidation(this.$refs.firstForm, this.validFormCallback, () => {})
    },
    validFormCallback() {
      const idxSpellError = this.studySetDetails.phrases.findIndex(tag => tag.spell_error);
      const idxLimitationError = this.studySetDetails.phrases.findIndex(tag => tag.limit_error);
      if (idxLimitationError > -1 || idxSpellError > -1){
        this.showModalSpellCheck = true;
        this.modalCheckType = (idxLimitationError > -1) ? "limit" : "spell";
      }else
        this.$emit('next-step', this.currentStep)
    },
    handleProceed() {
      this.$emit('next-step', this.currentStep)
    },
    handleCancelClick() {
      return this.$router.push({
        name: 'classes',
        params: {
          organizationId: this.currentOrganizationId
        }
      })
    },
    changeCategory(category) {
      this.updateBuildingStudySet({
        category: category
      })
    },
    changeShareable(shareable) {
      this.updateBuildingStudySet({
        shareable
      })
    },
    setTags(newPhrases) {
      this.updateBuildingStudySet({
        phrases: newPhrases
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  padding-bottom: 0px !important;
}

.form-row {
  margin-top: 20px;
}

.pick-category {
  font-weight: 600;
  font-size: 14px;
  color: #478dff;
  flex: 1;
  padding-left: 12px;
}

.pick-shareable-to {
  font-weight: 600;
  font-size: 14px;
  color: #478dff;
  flex: 1;
  padding-right: 12px;
}
.create-edit-form .form-row .el-form-item.elsa-input:not(:last-of-type) {
  margin-right: 0;
}

.input-phrases {
  width: 100%;
  height: 160px;
}

::v-deep .elsa-section {
  background-color: #f2f7fa;
}
::v-deep .el-date-editor.el-input {
  width: 200px;
}
::v-deep .elsa-input .el-input .el-input__inner {
  width: 100%;
  color:#121131;
  opacity: 1;
}

::v-deep .elsa-input .el-select .el-input__inner {
  color:#121131 !important;
  opacity: 1 !important;
}

::v-deep .elsa-tags-input {
  min-height: 190px;
  .ti-input .ti-new-tag-input {
    color: #B4B4B4;
    font-family: 'SF Pro Display';
    font-size: 16px;
    line-height: 24px;
  }
}

::v-deep .ti-tag {
  background: #e9e9ec !important;
  border-radius: 4px !important;
}

::v-deep .el-form-item__label {
  line-height: 24px !important;
  font-weight: 600 !important;
  color:#121131 !important;
}
</style>
